// Import Swiper and modules
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';


/**
 *
 * @type {Swiper}
 */
const swiper = new Swiper('.section.labels-grid .navfilter', {
    slidesPerView: 5,
    speed: 500,
    spaceBetween: 30,
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        clickable: true
    },
});

/**
 *
 * @type {Swiper}
 */
const swiper2 = new Swiper('.section.NavBar .items .swiper', {
    slidesPerView: "auto",
    speed: 500,
    spaceBetween: 30,
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        clickable: true
    },
    on: {
        afterInit: function(e){
            if( e.wrapperEl.scrollWidth == e.wrapperEl.clientWidth ){
                e.$el.find('.swiper-wrapper').addClass('justify-content-center');
            } else {
                e.$el.find('.swiper-wrapper').removeClass('justify-content-center');
            }
        },
        beforeResize: function(e){
            if( e.wrapperEl.scrollWidth == e.wrapperEl.clientWidth ){
                e.$el.find('.swiper-wrapper').addClass('justify-content-center');
            } else {
                e.$el.find('.swiper-wrapper').removeClass('justify-content-center');
            }
        }
    }
});

/**
 *
 * @type {Swiper}
 */
const swiper3 = new Swiper('.single-label .gallery .swiper', {
    slidesPerView: 1,
    speed: 1000,
    spaceBetween: 0,
    mousewheel: true,
    modules: [Navigation, Pagination],
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
    }
});


